export default "__VITE_ASSET__DfHbZyOb__"